import { UserService } from '@/api/user'
import { CustomComponentContext, CustomComponentContextType } from '@/utils/contexts/CustomComponentContext'
import { useContext, useEffect } from 'react'

// eslint-disable-next-line react-refresh/only-export-components
export const specHideDepartmentName = [
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Department',
    name: 'department',
    type: 'text',
  },
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Manager ID',
    name: 'managerId',
    type: 'Integer',
  }
]

export default function HideDepartmentName() {
  const { setValue } = useContext<CustomComponentContextType>(CustomComponentContext)
  const { data: userData } = UserService.useGetProfile()

  useEffect(() => {
    if (userData) {
      setValue('department', userData.department)
      setValue('managerId', userData.employeeId)
    }
  }, [userData, setValue])

  return <></>
}
